// Cliente de la API de Zuchlag
// La API vive en https://api.zuchlag.de (subdominio separado).
// En desarrollo podemos sobreescribir la URL via VITE_API_URL.
const API_URL = import.meta.env.VITE_API_URL || 'https://api.zuchlag.de'

async function request(path, params = {}) {
  const url = new URL(`${API_URL}/api${path}`)
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v)
  })

  const res = await fetch(url.toString(), {
    headers: { Accept: 'application/json' }
  })

  if (!res.ok) {
    let message = `Fehler ${res.status}`
    try {
      const data = await res.json()
      if (data.error) message = data.error
    } catch (_) { /* sin cuerpo JSON */ }
    const err = new Error(message)
    err.status = res.status
    throw err
  }

  return res.json()
}

// Listado de lotes con filtros/paginación
export function fetchLots(params) {
  return request('/lots', params)
}

// Detalle de un lote (por id, external_id o slug)
export function fetchLot(id) {
  return request(`/lots/${encodeURIComponent(id)}`)
}

// Subastas
export function fetchAuctions(params) {
  return request('/auctions', params)
}

// Categorías
export function fetchCategories() {
  return request('/categories')
}

// Health check (útil para un indicador de estado)
export function fetchHealth() {
  return request('/health')
}
